<template>
  <div class="alnCt h36" style="width: 100%">
    <el-select
      class="mr10 selectItem"
      v-model="teamId"
      placeholder="请选择运动队"
      :disabled="disabled"
      @change="changeTeam"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in teamList"
        :key="index"
      ></el-option>
    </el-select>
    <el-select
      class="selectItem"
      v-model="groupId"
      placeholder="请选择运动组"
      :disabled="disabled"
      @change="changeGroup"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in groupList"
        :key="index"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import * as API_Member from "@/api/train/member";
export default {
  props: ["tId", "gId", "disabled"],
  data() {
    return {
      teamId: this.tId ? this.tId : undefined, // 运动队Id
      groupId: this.gId ? this.gId : undefined, // 运动组Id
      teamList: [], // 运动队列表
      groupList: [], // 运动组列表
    };
  },
  watch: {
    tId(newV, oldV) {
      // console.log("tId变化--", newV, oldV);
      if (this.teamId != newV) {
        this.teamId = newV;
        this._getGroup();
      }
    },
    gId(newV, oldV) {
      // console.log("gId变化--", newV, oldV);
      if (this.groupId != newV) {
        if (this.teamId || !newV) {
          this.groupId = newV;
        } else {
          console.error("请先设置运动队");
        }
      }
    },
  },
  async mounted() {
    this._getTeam();
  },
  methods: {
    _getTeam() {
      API_Member.teamList().then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.teamList = res.data;
          if (this.groupId) {
            this._getGroup();
          }
        }
      });
    },
    // 选择运动队
    // changeTeam(e) {
    //   this.groupList = [];
    //   this.groupId = null;
    //   // console.log(e);
    //   // console.log(this.teamId, "teamId");
    //   this._getGroup();
    //   this.$emit("change", {
    //     tId: this.teamId,
    //     gId: null,
    //   });
    // },
    changeTeam(e) {
      this.groupId = null;
      this._getGroup();
    },
    // 选择运动队
    changeGroup(e) {
      console.log(e, "e");
      this.$emit("change", {
        tId: this.teamId,
        gId: this.groupId,
      });
    },
    _getGroup() {
      // console.log(this.teamId);
      API_Member.groupList({ teamId: this.teamId }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.groupList = res.data;
          // 新增默认值
          console.log(this.groupId,'groupId');
          this.groupId = this.groupId || res.data.length ? res.data[0].id : '';
          this.$emit("change", {
            tId: this.teamId,
            gId: this.groupId || res.data.length ? res.data[0].id : ''
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
@import "/src/styles/common/common.less";

.h36 {
  height: 36px;
  line-height: 36px;
}

.selectItem {
  flex: 1;
  min-width: 190px;
}
</style>
